function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "Profile"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M12 10.875C14.4853 10.875 16.5 8.86027 16.5 6.375C16.5 3.88973 14.4853 1.875 12 1.875C9.51473 1.875 7.5 3.88973 7.5 6.375C7.5 8.86027 9.51473 10.875 12 10.875Z",
  stroke: "#121212",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.375 5.62497C15.375 7.90313 13.5282 9.74997 11.25 9.74997C10.3021 9.74997 9.4289 9.43024 8.7323 8.89272C9.48661 9.87027 10.6698 10.5 12 10.5C14.2782 10.5 16.125 8.65313 16.125 6.37497C16.125 5.04469 15.4953 3.86149 14.5178 3.10718C15.0553 3.80378 15.375 4.67701 15.375 5.62497Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M12 13.125C9.22095 13.125 6.67354 14.0766 4.70479 15.6574C3.43174 16.6796 3.43174 18.5704 4.70479 19.5926C6.67354 21.1734 9.22099 22.125 12 22.125C14.779 22.125 17.3265 21.1734 19.2952 19.5926C20.5683 18.5704 20.5683 16.6796 19.2952 15.6574C17.3265 14.0766 14.779 13.125 12 13.125Z",
  fill: "#1167CB",
  stroke: "#121212",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_4",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.45001 18.7529C6.31496 20.1593 8.67859 21 11.25 21C13.9426 21 16.4074 20.0781 18.3104 18.5502C19.1965 17.8387 19.3596 16.6385 18.7999 15.7471C18.8878 15.8134 18.9747 15.881 19.0604 15.9498C20.1465 16.8219 20.1465 18.4281 19.0604 19.3002C17.1574 20.8281 14.6926 21.75 12 21.75C9.30735 21.75 6.84251 20.8281 4.93954 19.3002C4.73951 19.1396 4.57635 18.9541 4.45001 18.7529Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_5",
  d: "M13.5 17.25C13.8125 17.375 14.7 17.55 15.75 17.25",
  stroke: "white",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_6",
  d: "M13.125 16.875C13.4375 17 14.325 17.175 15.375 16.875",
  stroke: "#121212",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

function SvgUserProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/userProfile.27df25af.svg";
export { ForwardRef as ReactComponent };